import '../common.css'
import './about.css'